import type {SkuType} from '@github-ui/copilot-chat-helpers/sku-types'

import type {SkuBannerConfig} from './types'

export const SKU_BANNER_CONFIGS: Record<SkuType, SkuBannerConfig> = {
  trial: {
    title: 'Copilot Pro trial activated',
    description: 'Your 30-day Copilot Pro trial is now active.',
    dismissTarget: 'TRIAL_SUCCESS_BANNER_DISMISS',
    clearFlagsOnDismiss: [],
  },
  max: {
    title: 'Copilot Max activated',
    description: 'Your Copilot Max subscription is now active.',
    dismissTarget: 'MAX_SUCCESS_BANNER_DISMISS',
    clearFlagsOnDismiss: ['pro_plus', 'trial'],
  },
  // eslint-disable-next-line camelcase
  pro_plus: {
    title: 'Copilot Pro+ activated',
    description: 'Your Copilot Pro+ subscription is now active.',
    dismissTarget: 'PRO_PLUS_SUCCESS_BANNER_DISMISS',
    clearFlagsOnDismiss: ['trial'],
  },
}
